import {
  FC,
  useState,
  useEffect,
  createContext,
  useContext,
  useRef,
  Dispatch,
  SetStateAction,
} from 'react'
import {useQuery} from 'react-query'
import {LayoutSplashScreen} from '../../../../_metronic/layout/core'
import {AuthModel, UserAccess, UserModel} from './_models'
import * as authHelper from './AuthHelpers'
import {getUserByToken,getUserAccess} from './_requests'
import {WithChildren} from '../../../../_metronic/helpers'


type AuthContextProps = {
  auth: AuthModel | undefined
  saveAuth: (auth: AuthModel | undefined) => void
  currentUser: UserModel | undefined
  setCurrentUser: Dispatch<SetStateAction<UserModel | undefined>>
  accessUser: UserAccess | undefined
  setAccessUser: Dispatch<SetStateAction<UserAccess | undefined>>
  logout: () => void
}

const initAuthContextPropsState = {
  auth: authHelper.getAuth(),
  saveAuth: () => {},
  currentUser: undefined,
  setCurrentUser: () => {},
  accessUser: undefined,
  setAccessUser: () => {},
  logout: () => {}

}

const AuthContext = createContext<AuthContextProps>(initAuthContextPropsState)

const useAuth = () => {
  return useContext(AuthContext)
}



const AuthProvider: FC<WithChildren> = ({children}) => {
  const [auth, setAuth] = useState<AuthModel | undefined>(authHelper.getAuth())
  const [currentUser, setCurrentUser] = useState<UserModel | undefined>()
  const [accessUser, setAccessUser] = useState<UserAccess | undefined>()
  const saveAuth = (auth: AuthModel | undefined) => {
    setAuth(auth)
    if (auth) {
      authHelper.setAuth(auth)
    } else {
      authHelper.removeAuth()
    }
  }

  const logout = () => {
    saveAuth(undefined)
    setCurrentUser(undefined)
  }



  return (
    <AuthContext.Provider value={{auth, saveAuth, currentUser, setCurrentUser, accessUser,setAccessUser,logout}}>
      {children}
    </AuthContext.Provider>
  )
}

const AuthInit: FC<WithChildren> = ({children}) => {

  const {auth, logout, setCurrentUser,setAccessUser} = useAuth()
  const didRequest = useRef(false)
  const [showSplashScreen, setShowSplashScreen] = useState(true)
  useEffect(() => {
   
  
    const requestUser = async (apiToken: string) => {
      try {
        if (!didRequest.current) {

          const {data} = await getUserByToken(apiToken)
          if (data) {
            setCurrentUser(data)  
            requestAccess()
          }    
         
        }
      } catch (error) {
        console.error(error)
        if (!didRequest.current) {
          logout()
        }
      } finally {
        setShowSplashScreen(false)
      }

      return () => (didRequest.current = true)
    }

    const requestAccess = async () => {
      const {data} = await getUserAccess()
          if (data) {
            setAccessUser(data)                 
          } 

    }

    if (auth && auth.api_token) {
      requestUser(auth.api_token)

       
    
    } else {
      logout()
      setShowSplashScreen(false)
    }
    // eslint-disable-next-line
  }, [])

  return showSplashScreen ? <LayoutSplashScreen /> : <>{children}</>
}

export {AuthProvider, AuthInit, useAuth}